module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-22.56fdec8f.png";